var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_vm._v("SM Tools © "+_vm._s(_vm.yearNow))])])
}
var staticRenderFns = []

export { render, staticRenderFns }